import { motion } from "framer-motion";
import { Phone, FileText } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/data";

const StickyBar = () => (
  <motion.div
    data-testid="sticky-cta-bar"
    initial={{ opacity: 0, y: 40 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.7, delay: 1.6 }}
    className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-6 z-40 flex gap-2 sm:gap-3"
  >
    <a
      data-testid="sticky-call-floating-button"
      href={PHONE_TEL}
      className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full bg-sky-400 px-6 py-3.5 text-sm font-bold text-[#0A1220] shadow-[0_8px_30px_rgba(56,189,248,0.35)] hover:bg-sky-300 transition-colors duration-300"
    >
      <Phone className="w-4 h-4" />
      Appeler — {PHONE_DISPLAY}
    </a>
    <button
      data-testid="sticky-quote-button"
      onClick={() => scrollToId("contact")}
      className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 rounded-full glass px-6 py-3.5 text-sm font-semibold text-slate-900 hover:border-sky-400 hover:text-sky-600 transition-colors duration-300"
    >
      <FileText className="w-4 h-4" />
      Soumission
    </button>
  </motion.div>
);

export default StickyBar;
